module.exports = __webpack_public_path__ + "assets/webgl/art_063_L0.jpg.pvr.b6b78851.ktx";